import { forwardRef } from 'react';
import MuiBox, { type BoxProps as MuiBoxProps } from '@mui/material/Box';

export interface BoxProps extends MuiBoxProps {}

const Box = forwardRef<HTMLDivElement, BoxProps>((props, ref) => {
  return <MuiBox ref={ref} {...props} />;
});

Box.displayName = 'Box';

export default Box;
